<div *ngIf="dataSource && dataSource.data.length == 0" style="text-align:center;">No absences exist for the student.</div>

<div *ngIf="dataSource && dataSource.data.length > 0">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSort matSortDisableClear matSortActive="Date"
        matSortDirection="desc" tabindex="0">

        <ng-container matColumnDef="Date">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px; max-width:150px;">
                <span translate>Date</span>
                <filter class="mat-filter" [data]="dataSource" columnName="Date" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let attend" style="min-width:150px; max-width:150px;">
                {{attend.Date|date:'MM/dd/yy'}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Absent Count">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px; max-width:150px;">
                <span translate>Absent Count</span>
                <filter class="mat-filter" [data]="dataSource" columnName="Absent Count" dataType="number"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let attend" style="min-width:150px; max-width:150px;">
                {{attend.AbsentCount}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Code">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;">
                <span translate>Code</span>
                <filter class="mat-filter" [data]="dataSource" columnName="Code" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let attend" style="min-width:150px;">
                {{attend.Code}}
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay" tabindex="0" style="padding:0px;overflow: hidden;"
            matRipple>
        </mat-row>
    </mat-table>
</div>